import React from 'react';
import LoginForm from './components/LoginForm';

export default function Login({ onLogin }) {
  return (
    <div className="login-page">
      <LoginForm onLogin={onLogin} />
    </div>
  );
}
